import { Component, Input, OnInit } from '@angular/core';
import { NG_VALUE_ACCESSOR, ControlValueAccessor } from '@angular/forms';

@Component({
  selector: 'form-checkbox',
  templateUrl: './checkbox.component.html',
  providers: [{
    provide: NG_VALUE_ACCESSOR,
    useExisting: CheckboxComponent,
    multi: true
  }]
})
export class CheckboxComponent implements OnInit, ControlValueAccessor {

  // Internal checkbox check state
  private _checked = false;

  @Input() value: string;
  @Input() icon: string;
  @Input() name: string;
  @Input() label: string;
  @Input() required = false;
  @Input() readonly = false;
  @Input() disabled = false;
  @Input()
  get checked(): boolean { return this._checked; }
  set checked(value: boolean) {
    if (value !== this.checked) {
      this._onChangeFn(value);
      this._checked = value;
    }
  }

  // It will have a reference to a function that handles changing state of the control
  private _onChangeFn: (value: any) => void = _ => { };



  constructor() { }

  ngOnInit() {
  }

  onCheckboxClick() {
    this.toggle();
    // this._onChangeFn(this.checked);
  }

  toggle() {
    this.checked = !this.checked;
  }


  writeValue(value: any) {

    // This ensures that checked value always will be a boolean. 
    // !!'abc' will return true, !!null - false, empty string is falsy.
    this.checked = !!value;

  }


  registerOnChange(fn) { this._onChangeFn = fn; }

  // TODO: Implement this
  registerOnTouched(fn) { }

  setDisabledState(isDisabled: boolean) {
    this.readonly = isDisabled;
  }
}
